  
(function() {
    const forms = document.querySelectorAll('form');
    if (forms.length === 0) return;

    // Fonction pour attacher l'écouteur d'événement
    const addFocusListener = (autocompleteElement) => {
        // Vérifie si l'écouteur a déjà été ajouté pour éviter les doublons
        if (autocompleteElement.dataset.focusListenerAdded) return;

        autocompleteElement.addEventListener('focus', function() {
            const parent = this.closest('.fui-field');
            if (parent) {
                parent.classList.add('is-focused');
            }
        });

        // Marque l'élément comme traité
        autocompleteElement.dataset.focusListenerAdded = 'true';
    };

    const addInputListener = (autocompleteElement) => {
        // Vérifie si l'écouteur a déjà été ajouté pour éviter les doublons
        if (autocompleteElement.dataset.inputListenerAdded) return;

        // utiliser l'event 'input' pour détecter le champs vide
        autocompleteElement.addEventListener('input', function() {
            if (this.value === '') {
                resetAllAddressFields(this);
            } else {
                clearAutocompleteFieldError(this);
            }
        });

        // Marque l'élément comme traité
        autocompleteElement.dataset.inputListenerAdded = 'true';
    };

    // Trouve le champ hidden [data-raw-address] associé au champ autocomplete
    const getRawAutocompleteField = (autocompleteElement) => {
        const addressGroup = getAddressGroup(autocompleteElement);
        if (addressGroup) {
            const field = addressGroup.querySelector('[data-raw-address]');
            if (field) return field;
        }
        const form = autocompleteElement.closest('form');
        if (!form) return null;
        const allRawFields = Array.from(form.querySelectorAll('[data-raw-address]'));
        if (allRawFields.length <= 1) return allRawFields[0] || null;
        if (!addressGroup) return allRawFields[0];
        // Le rawAddress est toujours AVANT l'addressGroup dans le DOM :
        // prendre le dernier [data-raw-address] qui précède le groupe courant
        const preceding = allRawFields.filter(f =>
            addressGroup.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_PRECEDING
        );
        return preceding.length > 0 ? preceding[preceding.length - 1] : allRawFields[0];
    };

    const addRawSyncListener = (autocompleteElement) => {
        // Vérifie si l'écouteur a déjà été ajouté pour éviter les doublons
        if (autocompleteElement.dataset.rawSyncListenerAdded) return;

        // Cas 1 : saisie libre sans sélection de suggestion
        autocompleteElement.addEventListener('input', function() {
            const rawField = getRawAutocompleteField(this);
            if (rawField) {
                rawField.value = this.value || '';
            }
        });

        // Marque l'élément comme traité
        autocompleteElement.dataset.rawSyncListenerAdded = 'true';
    };

    // Retourne le conteneur parent [data-field-type="address"] d'un champ autocomplete
    const getAddressGroup = (autocompleteElement) => {
        return autocompleteElement.closest('[data-field-type="address"]');
    };

    // Efface l'erreur Formie du champ autocomplete quand il est complété
    const clearAutocompleteFieldError = (autocompleteElement) => {
        const autocompleteField = autocompleteElement.closest('[data-field-type="address-auto-complete"]');
        if (!autocompleteField) return;

        // Retirer la classe d'erreur du conteneur
        autocompleteField.classList.remove('fui-error');

        // Supprimer les messages d'erreur (natifs Formie + injectés)
        const errorContainer = autocompleteField.querySelector('[data-field-error-messages]');
        if (errorContainer) {
            errorContainer.remove();
        }

        // Nettoyer l'input hidden associé
        const hiddenInput = autocompleteField.querySelector('input[data-field-has-error]');
        if (hiddenInput) {
            hiddenInput.classList.remove('fui-error');
            hiddenInput.removeAttribute('data-field-has-error');
            hiddenInput.removeAttribute('aria-invalid');
            hiddenInput.removeAttribute('aria-describedby');
        }
    };

    const resetAllAddressFields = (autocompleteElement) => {
        const addressGroup = getAddressGroup(autocompleteElement);
        if (!addressGroup) return;

        const fields = addressGroup.querySelectorAll('input, select, textarea');
        for (const field of fields) {
            // Ne pas vider le champ autocomplete lui-même
            if (field === autocompleteElement) continue;

            field.value = '';

            // Déclencher un événement 'change' pour que Formie détecte la modification
            field.dispatchEvent(new Event('change', { bubbles: true }));
        }
    };

    const addClickListener = (autocompleteElement) => {
        // Vérifie si l'écouteur a déjà été ajouté pour éviter les doublons
        if (autocompleteElement.dataset.clickListenerAdded) return;

        autocompleteElement.addEventListener('click', function() {
            if(this.value === '') {
                resetAllAddressFields(this);
            }
        });

        // Marque l'élément comme traité
        autocompleteElement.dataset.clickListenerAdded = 'true';
    };

    // Traductions pour les messages d'erreur d'adresse
    const addressI18n = {
        en: { addressIncomplete: 'Address is incomplete', isMissing: 'is missing', areMissing: 'are missing' },
        fr: { addressIncomplete: "L'adresse est incomplète", isMissing: 'est manquant(e)', areMissing: 'sont manquant(e)s' },
        es: { addressIncomplete: 'La dirección está incompleta', isMissing: 'falta', areMissing: 'faltan' },
    };

    const getAddressI18n = () => {
        const lang = document.documentElement.lang || 'en';
        return addressI18n[lang] || addressI18n['en'];
    };

    // Récupère le texte du label d'un sous-champ, nettoyé (sans * ni &nbsp;)
    const getSubFieldLabel = (subField) => {
        const labelEl = subField.querySelector('[data-field-label]');
        if (!labelEl) return null;
        return labelEl.textContent.replace(/[\s*]+$/g, '').replace(/\u00A0/g, '').trim();
    };

    // Après validation Formie, affiche un message consolidé au niveau du champ autocomplete.
    // Priorité : erreur Formie du champ data-raw-address (autocomplete vide),
    // sinon message construit à partir des labels des sous-champs requis manquants.
    const showAddressErrorsInAutocomplete = (addressGroup, errorObserver, rawAddressContainer) => {
        // Trouver le conteneur du champ autocomplete
        const autocompleteField = addressGroup.querySelector('[data-field-type="address-auto-complete"]');
        if (!autocompleteField) return;

        // Helper : réactiver l'observer sur les deux cibles (addressGroup + rawAddressContainer)
        const reobserve = () => {
            if (!errorObserver) return;
            errorObserver.observe(addressGroup, observerOptions);
            if (rawAddressContainer) errorObserver.observe(rawAddressContainer, observerOptions);
        };

        // Erreur Formie sur le champ data-raw-address (ex: "Address is required")
        const rawAddressErrorEl = rawAddressContainer
            ? rawAddressContainer.querySelector('[data-field-error-message]')
            : null;
        const rawAddressErrorMessage = rawAddressErrorEl ? rawAddressErrorEl.textContent.trim() : null;

        // Sous-champs hors autocomplete et hors raw-address
        const subFields = Array.from(
            addressGroup.querySelectorAll('.fui-field:not([data-field-type="address-auto-complete"])')
        ).filter(sf => sf !== rawAddressContainer);

        const hasAnySubFieldError = subFields.some(sf => sf.querySelector('[data-field-error-message]'));
        const hasAnyError = !!rawAddressErrorMessage || hasAnySubFieldError;

        // Si aucune erreur, on nettoie et sort
        if (!hasAnyError) {
            // Désactiver l'observer pendant les modifications DOM
            if (errorObserver) errorObserver.disconnect();

            let errorContainer = autocompleteField.querySelector('[data-field-error-messages]');
            if (errorContainer) {
                const previousErrors = errorContainer.querySelectorAll('[data-address-subfield-error], [data-raw-address-field-error]');
                for (const prev of previousErrors) {
                    prev.remove();
                }
                if (errorContainer.children.length === 0) {
                    errorContainer.remove();
                }
            }
            autocompleteField.classList.remove('fui-error');

            // Réactiver l'observer
            reobserve();
            return;
        }

        let message;
        let errorAttr;

        if (rawAddressErrorMessage) {
            // Le champ data-raw-address a une erreur Formie → autocomplete vide,
            // utiliser directement le message configuré dans Formie
            message = rawAddressErrorMessage;
            errorAttr = 'data-raw-address-field-error';
        } else {
            // Le champ raw address est rempli mais des sous-champs sont incomplets
            errorAttr = 'data-address-subfield-error';

            const missingLabels = [];
            for (const subField of subFields) {
                const requiredInput = subField.querySelector('input[required], select[required], textarea[required]');
                if (requiredInput && (!requiredInput.value || requiredInput.value.trim() === '')) {
                    const label = getSubFieldLabel(subField);
                    if (label) missingLabels.push(label);
                }
            }

            if (missingLabels.length === 0) {
                // Pas de champ requis manquant => pas d'erreur à afficher
                if (errorObserver) errorObserver.disconnect();
                let errorContainer = autocompleteField.querySelector('[data-field-error-messages]');
                if (errorContainer) {
                    const previousErrors = errorContainer.querySelectorAll('[data-address-subfield-error], [data-raw-address-field-error]');
                    for (const prev of previousErrors) prev.remove();
                    if (errorContainer.children.length === 0) errorContainer.remove();
                }
                autocompleteField.classList.remove('fui-error');
                reobserve();
                return;
            }

            const i18n = getAddressI18n();
            if (missingLabels.length === 1) {
                message = `${i18n.addressIncomplete}: ${missingLabels[0]} ${i18n.isMissing}`;
            } else {
                message = `${i18n.addressIncomplete}: ${missingLabels.join(', ')} ${i18n.areMissing}`;
            }
        }

        // Désactiver l'observer pendant les modifications DOM pour éviter une boucle infinie
        if (errorObserver) errorObserver.disconnect();

        // Trouver ou créer le conteneur d'erreurs
        let errorContainer = autocompleteField.querySelector('[data-field-error-messages]');

        // Nettoyer les erreurs précédemment injectées par ce script
        if (errorContainer) {
            const previousErrors = errorContainer.querySelectorAll('[data-address-subfield-error], [data-raw-address-field-error]');
            for (const prev of previousErrors) {
                prev.remove();
            }
        }

        // Créer le conteneur s'il n'existe pas
        if (!errorContainer) {
            errorContainer = document.createElement('div');
            errorContainer.setAttribute('data-field-error-messages', '');
            errorContainer.classList.add('fui-errors');
            autocompleteField.appendChild(errorContainer);
        }

        // Ajouter le message d'erreur
        const errorDiv = document.createElement('div');
        errorDiv.setAttribute('data-field-error-message', '');
        errorDiv.setAttribute(errorAttr, '');
        errorDiv.classList.add('fui-error-message');
        errorDiv.setAttribute('aria-live', 'polite');
        errorDiv.setAttribute('aria-atomic', 'true');
        errorDiv.textContent = message.endsWith('.') ? message : message + '.';
        errorContainer.appendChild(errorDiv);

        // Ajouter la classe d'erreur au champ autocomplete
        autocompleteField.classList.add('fui-error');

        // Réactiver l'observer après les modifications
        reobserve();
    };

    // Options de configuration de l'observer (référencées à plusieurs endroits)
    const observerOptions = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-field-has-error']
    };

    // Observer les address groups pour détecter quand Formie ajoute des erreurs
    const observeAddressGroupErrors = (addressGroup) => {
        let debounceTimer = null;

        // Utiliser getRawAutocompleteField pour trouver le bon rawAddress,
        // même logique que pour la synchro input/submit (gère les multi-paires)
        const autocompleteEl = addressGroup.querySelector('gmp-place-autocomplete');
        const rawAddressInput = autocompleteEl ? getRawAutocompleteField(autocompleteEl) : null;
        const rawAddressContainer = rawAddressInput ? rawAddressInput.closest('.fui-field') : null;

        const errorObserver = new MutationObserver(() => {
            // Debounce pour regrouper les mutations rapides de Formie
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                showAddressErrorsInAutocomplete(addressGroup, errorObserver, rawAddressContainer);
            }, 100);
        });

        errorObserver.observe(addressGroup, observerOptions);
        if (rawAddressContainer) {
            errorObserver.observe(rawAddressContainer, observerOptions);
        }
    };

    // Garder une trace des address groups déjà observés pour éviter les doublons
    const observedAddressGroups = new Set();

    const attachAddressGroupObserver = (autocompleteElement) => {
        const addressGroup = getAddressGroup(autocompleteElement);
        if (addressGroup && !observedAddressGroups.has(addressGroup)) {
            observedAddressGroups.add(addressGroup);
            observeAddressGroupErrors(addressGroup);
        }
    };

    for (const form of forms) {
        // Cas 2 : à la soumission, synchroniser les champs autocomplete → data-raw-address
        // si la valeur diffère (ex: suggestion sélectionnée non capturée par input)
        form.addEventListener('submit', function() {
            const autocompletes = this.querySelectorAll('gmp-place-autocomplete');
            for (const autocomplete of autocompletes) {
                const rawField = getRawAutocompleteField(autocomplete);
                if (rawField && autocomplete.value !== rawField.value) {
                    rawField.value = autocomplete.value || '';
                }
            }
        }, { capture: true });

        // Gère les champs déjà présents au chargement de la page
        const initialAutocompletes = form.querySelectorAll('gmp-place-autocomplete');
        for (const autocomplete of initialAutocompletes) {
            addFocusListener(autocomplete);
            addInputListener(autocomplete);
            addClickListener(autocomplete);
            addRawSyncListener(autocomplete);
            attachAddressGroupObserver(autocomplete);
        }

        // Observe les changements dans le formulaire pour les champs ajoutés dynamiquement
        const observerConfig = { childList: true, subtree: true };
        const observer = new MutationObserver(function(mutationList) {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    for (const node of mutation.addedNodes) {
                        // S'assure que le noeud est un élément HTML
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            // Si le noeud ajouté est lui-même un champ d'autocomplétion
                            if (node.matches('gmp-place-autocomplete')) {
                                addFocusListener(node);
                                addInputListener(node);
                                addClickListener(node);
                                addRawSyncListener(node);
                                attachAddressGroupObserver(node);
                            } else {
                                // Recherche les champs d'autocomplétion dans le noeud ajouté
                                const newAutocompletes = node.querySelectorAll('gmp-place-autocomplete');
                                for (const autocomplete of newAutocompletes) {
                                    addFocusListener(autocomplete);
                                    addInputListener(autocomplete);
                                    addClickListener(autocomplete);
                                    addRawSyncListener(autocomplete);
                                    attachAddressGroupObserver(autocomplete);
                                }
                            }
                        }
                    }
                }
            }
        });

        observer.observe(form, observerConfig);
    }
})();
